"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Link_1 = __importDefault(require("@mui/material/Link"));
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Link = ({ to, external, ...rest }) => to ? (react_1.default.createElement(Link_1.default, { component: react_router_dom_1.Link, to: to, ...rest, sx: { '&:hover': { textDecoration: 'none' } } })) : (react_1.default.createElement(Link_1.default, { target: external ? '_blank' : undefined, rel: external ? 'noopener noreferrer' : undefined, ...rest }));
exports.default = Link;
